module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAAAwAgMAAAD7ixVkAAAACVBMVEUAAADdAAD/zgDGIigcAAAAG0lEQVQoz2NgGAVUBaFYwKgg+YKrsIBRQbIFAbpUPtBQ8ZOVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/flags/de.png
// module id = iPXY
// module chunks = 2